module.exports = __webpack_public_path__ + "assets/img/NVIDIA-db446319.png";